import React from 'react';
import { getFeaturedLeaderInputs } from './TopLeaderCardUtils';
import { useTopLeaderCardQuery } from './useTopLeaderCardQuery';
import { LeaderImageCard } from '../../LeaderImageCard/LeaderImageCard';

interface ITopLeaderCardProps {
    maxGridWidth: number;
}

const TopLeaderCard = ({
    maxGridWidth,
}: ITopLeaderCardProps): React.ReactNode => {
    const { leader, page } = useTopLeaderCardQuery();
    const {
        image,
        name,
        pageUrl,
        position,
        secondary,
        featuredCopy,
        maxWidth,
        topLeader,
    } = getFeaturedLeaderInputs(leader, page, maxGridWidth);

    return (
        <div className={`top-leadership`}>
            <LeaderImageCard
                inputs={{
                    image,
                    name,
                    pageUrl,
                    position,
                    secondary,
                    topLeader,
                    featuredCopy,
                    maxWidth,
                }}
            />
        </div>
    );
};

export default TopLeaderCard;
